import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppRootService } from 'app/shared/services/app-root/app-root-service';
import { ILabels } from 'libraries/interfaces/ILabels';
import { Yii } from 'libraries/interfaces/Yii';
import { AppHeaderTitleService, IAppHeaderTitleLoading, IAppHeaderTitleError } from 'app/shared/components/app-header-title/app-header-title.service';
import { Subscription } from 'rxjs';
import { faPen, IconDefinition } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'app-header-title',
    template: `
        <div *ngIf="!this.onEditingTitle" class="title-edit-icon">
            <h2 class="app-secondary-title">
                {{appRootService.currentAppConfig.secondaryName}}
            </h2>
            <fa-icon 
                    *ngIf="appRootService.currentAppConfig?.canEditTitle" 
                    [icon]="iconPen" 
                    class="edit-icon"
                    (click)="onEditingTitle = true;"></fa-icon>
        </div>
        <div *ngIf="onEditingTitle && appRootService.currentAppConfig?.canEditTitle && !loader?.isActive" class="field">
            <input
                autofocus
                #titleField [value]="appRootService.currentAppConfig?.secondaryName"
                (keyup.enter)="setTitle(titleField.value)"
                (keyup.esc)="onEditingTitle = false">
            <btn type="actionUndo" (click)="onEditingTitle = false" [label]="wording.cancel"></btn>
            <btn type="actionDo" (click)="setTitle(titleField.value)" [label]="wording.validate"></btn>
        </div>

        <notification *ngIf="errorNotification?.isActive" type="error">{{ errorNotification.message }}</notification>
        <loader *ngIf="onEditingTitle && loader?.isActive" [message]="loader.message" type="small"><loader>
    `,
    styles: [`
        .title-edit-icon {
            display: flex;
            align-items: center;
        }

        .app-secondary-title-wrapper {
            position: relative;
        }

        .close-icon {
            cursor: pointer;
        }

        .title {
            display: flex;
            align-items: center;
        }

        .edit-icon {
            margin-left: .75rem;
            cursor: pointer;
        }

        .panel {
            position: absolute;
            min-width: 250px;
            margin-top: .75rem;
        }

        .panel-header {
            text-align: right;
        }

        .panel-content {
            padding: .75rem;
            text-align: initial;
            color: initial;
        }

        .field {
            display: flex;
            align-items: center;
            margin-left: .75rem;
        }

        .field input {
            width: inherit;
            margin-right: .5rem;
        }

        btn {
            margin-right: .25rem;
        }
    `]
})
export class AppHeaderTitleComponent implements OnInit, OnDestroy {
    public wording: ILabels = {
        editTitle: Yii.t('wui-watabi-js', 'Modifier le titre'),
        cancel: Yii.t('wui-watabi-js', 'Annuler'),
        validate: Yii.t('wui-watabi-js', 'Valider'),
    };

    public onEditingTitle: boolean = false;
    public loader: IAppHeaderTitleLoading;
    public errorNotification: IAppHeaderTitleError;

    public iconPen: IconDefinition = faPen;

    private readonly subscriptions: Subscription = new Subscription();

    constructor(
        public appRootService: AppRootService,
        private readonly appHeaderTitleService: AppHeaderTitleService,
    ) {}

    public ngOnInit(): void {
        const loading: Subscription = this.appHeaderTitleService.getLoading().subscribe({
            next: (loader: IAppHeaderTitleLoading): void => {
                this.loader = loader;
                this.onEditingTitle = loader.isActive;
            }
        });

        this.subscriptions.add(loading);

        const title: Subscription = this.appHeaderTitleService.getError().subscribe({
            next: (error: IAppHeaderTitleError): void => {
                this.errorNotification = error;
            }
        });

        this.subscriptions.add(title);
    }

    public setTitle(secondaryName: string): void {
        this.appRootService.setAppConfig({
            ...this.appRootService.currentAppConfig,
            secondaryName
        });

        this.appHeaderTitleService.setError({ isActive: false });
        this.appHeaderTitleService.setHeaderTitle(secondaryName);
    }

    public ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}